import React from 'react';
import { TrendingUp, ExternalLink } from 'lucide-react';
import { GameSummary } from '@/api/types';
import { useTrackClick } from '@/hooks';
import { buildImageUrl } from '@/utils/image-url';
import { calculateHeat } from '@/utils/heat-score';
import styles from './mobile-game-card.module.css';

interface MobileGameCardProps {
  game: GameSummary;
  index?: number;
}

export const MobileGameCard: React.FC<MobileGameCardProps> = ({ game, index }) => {
  const trackClick = useTrackClick();
  const heatScore = calculateHeat(game.viewCount, 0);

  const handleClick = () => {
    trackClick.mutate({ gameId: parseInt(game.id, 10) || 0, platformId: 'default' });
  };

  return (
    <a
      href={`/game/${game.id}`}
      className={styles.card}
      onClick={handleClick}
    >
      {index !== undefined && index < 3 && (
        <div className={`${styles.rank} ${styles[`rank${index + 1}`]}`}>
          {index + 1}
        </div>
      )}
      <div className={styles.cover}>
        <img
          src={buildImageUrl(game.cover)}
          alt={game.title}
          className={styles.image}
          loading="lazy"
          onError={(e) => {
            (e.target as HTMLImageElement).src = '/fallback-cover.png';
          }}
        />
        <div className={styles.heat}>
          <TrendingUp size={12} />
          <span>{heatScore}</span>
        </div>
      </div>
      <div className={styles.info}>
        <h3 className={styles.name}>{game.title}</h3>
        <p className={styles.category}>{game.category}</p>
        <div className={styles.tags}>
          {game.platforms.slice(0, 2).map((platform) => (
            <span key={platform.id} className={styles.tag}>
              {platform.name}
            </span>
          ))}
        </div>
      </div>
      <div className={styles.action}>
        <ExternalLink size={18} className={styles.actionIcon} />
      </div>
    </a>
  );
};

export default MobileGameCard;
